import { APIScope, MemberInterface, PromptInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/UserValidation/UserValidation.Controller.ts
export class AuthAPI {
  static async checkAuth(token: string, scopes: APIScope[], orgId: number, groupId?: number, locationId?: number): Promise<MemberInterface> {
    return APIService.Server.post<MemberInterface>(`/auth/org/${orgId}/check`, { jwt: token, scopes });
  }

  static async generate2faSecretAndGetCode(orgId: number, userId: number, name: string): Promise<string> {
    return APIService.Server.get<string>(`/user-validation/org/${orgId}/user/${userId}/get-code`, { name });
  }
  static async verify2faCode(orgId: number, userId: number, code: string): Promise<boolean> {
    return APIService.Server.get<boolean>(`/user-validation/org/${orgId}/user/${userId}/validate`, { code });
  }

  static async getEventBusToken(orgId: number, userId: number): Promise<{ jwt: string; expiresIn: number }> {
    return APIService.Server.post<{ jwt: string; expiresIn: number }>(`/auth/event-bus-token`, { orgId, userId });
  }
}
